{
	"title": "Carbon captured attributes",
	"buttonTitle": "Carbon capture and storage",
	"table": {
		"materialDescription": "Material",
		"quantity": "Quantity",
		"productGwpTotal": "Product GWP Total",
		"bundledCarbonReductions": "Bundled carbon reductions",
		"remainingGwp": "Remaining GWP",
		"epdForPhysicalMaterial": "EPD for physical material",
		"carbonPlantName": "Brevik, Norway"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "is the rightful holder of the reported carbon reductions."
	},
	"modal": {
		"title": "Carbon capture and storage",
		"description": "Carbon Capture and Storage (CCS) is a technology that can capture the carbon dioxide (CO2) emissions produced from the calcination process and use of fuels in the kiln operation, preventing the carbon dioxide from entering the atmosphere and storing it permanently underground. The captured CO2 from Heidelberg Materials' plant in Brevik, Norway, is compressed and transported through to a storage site beneath the North Sea. The facility at our Brevik plant will capture 400,000 tonnes of CO2 annually.",
		"showLink": "Learn more on the carbon capturing process",
		"buttonClose": "Close"
	},
	"footnote": "1) Carbon reductions compensate for stages A1-A3 of the lifecycle inventory of cement."
}
